const getServerURL = () => {
  return (
    process.env.REACT_APP_FEATURE_FLAG_SERVER_URL ||
    'https://cncflags.dev.aws.castandcrew.com'
  );
};

module.exports = getServerURL;
